export default function DataState({ loading, empty, emptyText = "No data found.", children }) {
  if (loading) return <div className="rtv2-state">Loading…</div>;
  if (empty) return <div className="rtv2-state">{emptyText}</div>;
  return children;
}
